import type { ShopperSearch } from '@/scapi';
import type { ButtonVariantOptions } from '@/components/ui/button';
import { WishlistIconButton, type WishlistIconButtonProps } from '@/components/buttons/wishlist-icon-button';

export type WishlistButtonProps = {
    product: ShopperSearch.schemas['ProductSearchHit'];
    variant?: ShopperSearch.schemas['ProductSearchHit'];
    size?: 'sm' | 'md' | 'lg';
    hierarchy?: ButtonVariantOptions['hierarchy'];
    className?: string;
    tabIndex?: number;
};

const mapSize = (size: WishlistButtonProps['size']): WishlistIconButtonProps['size'] => {
    return size === 'lg' ? 'icon-large' : 'icon-small';
};

const WishlistButton = ({ product, variant, size = 'md', hierarchy, className, tabIndex }: WishlistButtonProps) => {
    return (
        <WishlistIconButton
            product={product}
            variant={variant}
            size={mapSize(size)}
            hierarchy={hierarchy}
            className={className}
            tabIndex={tabIndex}
        />
    );
};

export { WishlistButton };
